export const isBotblitzDomain = (): boolean =>
    typeof window !== 'undefined' && !!window.location.hostname && window.location.hostname.endsWith('botblitz.site');

/**
 * Everyman dtrader-c is an **embed-only** app: authentication is owned by the parent site, which hands
 * the session to this app via the URL query (`?token=…&account_id=…`) and reloads the iframe when the
 * account changes. There is deliberately **no in-app login** (no login button, no `oauth.deriv.com`
 * redirect — that is the legacy flow this deployment migrated away from).
 *
 * When a session is missing or expired the parent must re-embed the app with fresh credentials, so
 * this is a no-op kept for call-site compatibility.
 */
export const redirectToLogin = (
    _is_logged_in: boolean,
    _language: string,
    _has_params = true,
    _redirect_delay = 0
) => {
    // eslint-disable-next-line no-console
    console.warn('[dtrader-c][auth] login is parent-driven (query URL handoff) — redirectToLogin is a no-op');
};

// Same as root: single signup URL (track.deriv.com)
const ROOT_SIGNUP_URL = 'https://track.deriv.com/_5b97G5QPtjsKqFKZ7JdnQ2Nd7ZgqdRLk/1/';

export const redirectToSignUp = (_options?: { is_appstore?: boolean }) => {
    window.location.href = ROOT_SIGNUP_URL;
};
